import { MathUtil } from "@/MathUtil";
//import ProgressIndicator from './ProgressIndicator.vue';

export class SpinningWordAnimation
{
    //TODO: //public animateWordlet(word: Element, progressIndicator: ProgressIndicator): Promise<any>
    public animateWordlet(word: Element, progressIndicator: any): Promise<any>
    { 
        return new Promise((resolve, reject) => {
            const target = progressIndicator.$el;

            const rect1 = target.getClientRects()[0];
            const rect2 = word.getClientRects()[0];
            const center2 = MathUtil.centerPoint(rect2);
            const center1 = MathUtil.centerPoint(rect1);
            const deg = MathUtil.angleOf(rect1, rect2);

            const tx = Math.round(center1.x - center2.x);
            const ty = Math.round(center1.y - center2.y);

            //point the left end of the word towards the target and move towards target
            const a1: Animation = word.animate([{ transform: `translateX(0) translateY(0) rotate(0deg)` },
            { transform: `translateX(${tx}px) translateY(${ty}px) rotate(-${deg}deg)` }],
                { duration: 400, easing: "ease-in-out", fill: "forwards" });

            a1.onfinish = (ev: AnimationPlaybackEvent) => {
                //the word has done moving scale it and center it over the target.
                progressIndicator.setProgressing(true);
                const cp = MathUtil.centerPoint(target.getClientRects()[0]);
                const deg2 = 360 - deg;
                const a2: Animation = word.animate([{ transform: `scale(1) ` }, { transform: `scale(0) rotate(-${deg2}deg)` }],
                    { duration: 200, easing: "ease-in", fill: "forwards", composite: "add" });

                a2.onfinish = () => {
                    progressIndicator.setProgressing(false);
                    resolve(undefined);

                    //  this.pluckIt();
                    //  this.progressIndicator++;
                    //  setTimeout(()=>{
                    //    this.progressIndicatorExpanded=false;
                    //  },200)


                }
            };

        });

    }
}